var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#21D0C3"
    },
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#15BDB2"
    },
    cx: 256,
    cy: 421.646,
    rx: 182.284,
    ry: 14.369
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#666666"
    },
    d: "M65.979,67.222h380.037c12.485,0,22.702,10.217,22.702,22.702V324.03H43.282V89.922 c0-12.485,10.217-22.702,22.702-22.702L65.979,67.222L65.979,67.222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DCE3DB"
    },
    d: "M58.695,308.617h394.609V89.927c0-3.977-3.308-7.289-7.284-7.289H65.984 c-3.977,0-7.284,3.307-7.284,7.289v218.69H58.695z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M468.718,324.03v24.826c0,12.49-11.261,22.702-25.024,22.702H68.307 c-13.764,0-25.024-10.212-25.024-22.702V324.03H468.718z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M141.237,115.529h229.525h34.165c4.143,0,7.528,3.39,7.528,7.528v44.793v140.767H99.544V167.851 v-44.793c0-4.143,3.385-7.528,7.528-7.528L141.237,115.529L141.237,115.529z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 166.505,
    y: 186.496,
    style: {
      fill: "#ECF0F1"
    },
    width: 179.719,
    height: 25.091
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#828282"
    },
    d: "M107.072,115.529h297.855c4.143,0,7.528,3.385,7.528,7.528v15.053H99.544v-15.053 C99.544,118.915,102.929,115.529,107.072,115.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.385,123.326h163.62c1.113,0,2.023,0.914,2.023,2.023v3.751c0,1.109-0.91,2.023-2.023,2.023 h-163.62c-1.109,0-2.018-0.91-2.018-2.023v-3.751C224.366,124.235,225.276,123.326,226.385,123.326z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M117.335,121.982c2.392,0,4.333,1.94,4.333,4.333s-1.94,4.333-4.333,4.333 c-2.397,0-4.337-1.94-4.337-4.333C112.998,123.917,114.939,121.982,117.335,121.982z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 166.505,
    y: 224.162,
    style: {
      fill: "#ECF0F1"
    },
    width: 179.719,
    height: 25.091
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FAD24D"
    },
    d: "M134.438,121.982c2.397,0,4.333,1.94,4.333,4.333s-1.94,4.333-4.333,4.333s-4.333-1.94-4.333-4.333 C130.106,123.917,132.046,121.982,134.438,121.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF5B62"
    },
    d: "M151.551,121.982c2.392,0,4.333,1.94,4.333,4.333s-1.94,4.333-4.333,4.333 c-2.397,0-4.338-1.94-4.338-4.333C147.214,123.917,149.154,121.982,151.551,121.982z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#21D0C3"
    },
    d: "M221.119,261.303h69.762c3.058,0,5.538,2.479,5.538,5.538v9.533c0,3.058-2.479,5.538-5.538,5.538 h-69.762c-3.058,0-5.538-2.479-5.538-5.538v-9.533C215.581,263.782,218.06,261.303,221.119,261.303z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 183.162,
    cy: 199.041,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 203.532,
    cy: 199.041,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 223.893,
    cy: 199.041,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 244.263,
    cy: 199.041,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 183.162,
    cy: 236.708,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 203.532,
    cy: 236.708,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 223.893,
    cy: 236.708,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 244.263,
    cy: 236.708,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 264.633,
    cy: 236.708,
    r: 4.637
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#828282"
    },
    cx: 284.993,
    cy: 236.708,
    r: 4.637
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6B6B8"
    },
    cx: 256,
    cy: 346.803,
    r: 7.815
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C4"
    },
    d: "M305.065,407.27l36.096,11.565H170.839l29.121-11.565v-35.712h105.105V407.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B6B6B8"
    },
    d: "M305.065,407.27L199.96,371.557h105.105V407.27z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ECF0F1"
    },
    d: "M199.96,407.27h105.105l36.096,11.565v4.983H256h-85.166v-4.983l29.121-11.565H199.96z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.5daf960fe90e47c0220b3362ef32e239.svg";
export { ForwardRef as ReactComponent };